import React, { useState } from "react";
import { RiCloseFill, RiAddLine } from 'react-icons/ri';
import { post } from "../../utility/fetch";
import notification from "../../utility/notification";
import SpeechToTextButton from "../UI/SpeechToTextButton";
import TextPrediction from "../layouts/TextPrediction";

function MetricModal({ closeModal, getInternalLabService, data }) {
    const [metrics, setMetrics] = useState([
        {
            labServicesId: data?.id,
            parameter: "",
            description: "",
            unitOfMeasurement: "",
            normalRefRange: "",
            refRange_Male: "",
            refRange_FeMale: "",
            refRange_Elderly: "",
            refRange_Adult: "",
            refRange_Children: "",
            flag: "Normal"
        }
    ]);

    const addMetric = async () => {
        try {
            // Submit all metrics at once
            const res = await post(`/internallabservice/${data?.id}/add-test-details`, {
                labServiceTestDetails: metrics
            });
            if (res.statusCode === 200) {
                getInternalLabService();
                closeModal();
                notification({ message: res?.data?.message, type: "success" });
            } else {
                notification({ message: "Failed to add metrics", type: "error" });
            }
        } catch (error) {
            notification({ message: "An error occurred", type: "error" });
        }
    };

    const addNewMetricForm = () => {
        setMetrics([...metrics, {
            labServicesId: data?.id,
            parameter: "",
            description: "",
            unitOfMeasurement: "",
            normalRefRange: "",
            refRange_Male: "",
            refRange_FeMale: "",
            refRange_Elderly: "",
            refRange_Adult: "",
            refRange_Children: "",
            flag: "Normal"
        }]);
    };

    const removeMetricForm = (index) => {
        if (metrics.length <= 1) return;
        const updatedMetrics = [...metrics];
        updatedMetrics.splice(index, 1);
        setMetrics(updatedMetrics);
    };

    const onTranscript = (transcript, index) => {
        const updatedMetrics = [...metrics];
        updatedMetrics[index].description = updatedMetrics[index].description
            ? `${updatedMetrics[index].description} ${transcript}`
            : transcript;
        setMetrics(updatedMetrics);
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;
        const updatedMetrics = [...metrics];
        updatedMetrics[index][name] = value;
        setMetrics(updatedMetrics);
    };

    const isMobile = window.innerWidth < 768;

    return (
        <div className="metric-modal-overlay">
            <div className="metric-modal-container" style={isMobile ? { width: '95%' } : {}}>
                <div className="metric-modal-header">
                    <h2>{`Add Metrics to ${data?.name}`}</h2>
                    {/* <button onClick={closeModal} className="close-button">
                        <RiCloseFill />
                    </button> */}
                </div>

                <div className="metric-modal-content">
                    {metrics.map((metric, index) => (
                        <div key={index} className="metric-form-container">
                            <div className="form-header">
                                {/* <h3>Metric #{index + 1}</h3> */}
                                {metrics.length > 1 && (
                                    <button
                                        onClick={() => removeMetricForm(index)}
                                        className="remove-form-button"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>

                            <div className="form-row" style={isMobile ? { flexDirection: 'column', gap: 0 } : {}}>
                                <div className="form-group">
                                    <label>Parameter Name</label>
                                    <input
                                        type="text"
                                        name="parameter"
                                        value={metric.parameter}
                                        onChange={(e) => handleChange(e, index)}
                                        placeholder="Enter parameter name"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Unit of Measurement</label>
                                    <input
                                        type="text"
                                        name="unitOfMeasurement"
                                        value={metric.unitOfMeasurement}
                                        onChange={(e) => handleChange(e, index)}
                                        placeholder="e.g. mg/dL"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <TextPrediction
                                    value={metric.description}
                                    handleChange={(e) => handleChange(e, index)}
                                    name="description"
                                    type='textArea'
                                    label=''
                                />
                                <div style={{ marginTop: "8px" }} className="speech-to-text-container">
                                    <SpeechToTextButton onTranscript={(transcript) => onTranscript(transcript, index)} />
                                </div>
                            </div>

                            <div className="form-row" style={isMobile ? { flexDirection: 'column', gap: 0 } : {}}>
                                <div className="form-group">
                                    <label>Normal Reference Range</label>
                                    <input
                                        type="text"
                                        name="normalRefRange"
                                        value={metric.normalRefRange}
                                        onChange={(e) => handleChange(e, index)}
                                        placeholder="e.g. 0.5-1.5"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Flag</label>
                                    <select
                                        name="flag"
                                        value={metric.flag}
                                        onChange={(e) => handleChange(e, index)}
                                    >
                                        <option value="Normal">Normal</option>
                                        <option value="High">High</option>
                                        <option value="Low">Low</option>
                                        <option value="Critical">Critical</option>
                                    </select>
                                </div>
                            </div>

                            <div className="reference-ranges-section">
                                <h4>Specific Reference Ranges</h4>
                                <div className="form-row" style={isMobile ? { flexDirection: 'column', gap: 0 } : {}}>
                                    <div className="form-group">
                                        <label>Male</label>
                                        <input
                                            type="text"
                                            name="refRange_Male"
                                            value={metric.refRange_Male}
                                            onChange={(e) => handleChange(e, index)}
                                            placeholder="Male reference range"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Female</label>
                                        <input
                                            type="text"
                                            name="refRange_FeMale"
                                            value={metric.refRange_FeMale}
                                            onChange={(e) => handleChange(e, index)}
                                            placeholder="Female reference range"
                                        />
                                    </div>
                                </div>

                                <div className="form-row" style={isMobile ? { flexDirection: 'column', gap: 0 } : {}}>
                                    <div className="form-group">
                                        <label>Adult</label>
                                        <input
                                            type="text"
                                            name="refRange_Adult"
                                            value={metric.refRange_Adult}
                                            onChange={(e) => handleChange(e, index)}
                                            placeholder="Adult reference range"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Children</label>
                                        <input
                                            type="text"
                                            name="refRange_Children"
                                            value={metric.refRange_Children}
                                            onChange={(e) => handleChange(e, index)}
                                            placeholder="Children reference range"
                                        />
                                    </div>
                                </div>

                                <div className="form-row" style={isMobile ? { flexDirection: 'column', gap: 0 } : {}}>
                                    <div className="form-group">
                                        <label>Elderly</label>
                                        <input
                                            type="text"
                                            name="refRange_Elderly"
                                            value={metric.refRange_Elderly}
                                            onChange={(e) => handleChange(e, index)}
                                            placeholder="Elderly reference range"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div style={{display:"flex", justifyContent:"space-between", flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0}} className="form-actions w-100">
                        <div className="flex">
                            <button
                                onClick={addNewMetricForm}
                                className="add-metric-button"
                            >
                                <RiAddLine /> Add Another Metric
                            </button>

                            <button
                                onClick={addMetric}
                                className="submit-button"
                            >
                                Submit All Metrics
                            </button>
                        </div>

                        <div>
                            <button
                                onClick={closeModal}
                                className="close-metric-button">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MetricModal;